/**
 * Scrolls to a comment with the given ID
 * @param commentId - The ID of the comment to scroll to
 * @param options - Scroll options
 */
export const scrollToComment = (
  commentId: string,
  options: {
    behavior?: "smooth" | "instant";
    block?: "start" | "center" | "end" | "nearest";
    maxRetries?: number;
    retryDelay?: number;
  } = {},
) => {
  const { behavior = "smooth", block = "center", maxRetries = 5, retryDelay = 100 } = options;

  const attemptScroll = (attempt = 0): Promise<boolean> => {
    return new Promise((resolve) => {
      const element = document.getElementById(`comment-${commentId}`);

      if (element) {
        // Use scrollIntoView for better browser compatibility
        element.scrollIntoView({
          behavior,
          block,
        });

        // Optional: Add highlight effect
        element.style.transition = "background-color 0.3s ease";
        element.style.backgroundColor = "rgba(59, 130, 246, 0.1)"; // Light blue highlight

        setTimeout(() => {
          element.style.backgroundColor = "";
        }, 2000);

        resolve(true);
        return;
      }

      if (attempt < maxRetries) {
        setTimeout(() => {
          attemptScroll(attempt + 1).then(resolve);
        }, retryDelay);
      } else {
        console.warn(`Comment with ID ${commentId} not found after ${maxRetries} attempts`);
        resolve(false);
      }
    });
  };

  return attemptScroll();
};
